
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class EntityLinkGrid extends SiteEntityGrid<EntityLinkRow, any> {
        protected getColumnsKey() { return 'Data.EntityLink'; }
        protected getDialogType() { return EntityLinkDialog; }
        protected getIdProperty() { return EntityLinkRow.idProperty; }
        protected getInsertPermission() { return EntityLinkRow.insertPermission; }
        protected getLocalTextPrefix() { return EntityLinkRow.localTextPrefix; }
        protected getService() { return EntityLinkService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}